// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBSWiiO2NKWPspJ3hSRn88I6hMfMszCBQ0",
  authDomain: "mercatomusicale-468a4.firebaseapp.com",
  projectId: "mercatomusicale-468a4",
  storageBucket: "mercatomusicale-468a4.appspot.com",
  messagingSenderId: "16936502587",
  appId: "1:16936502587:web:69e4073375b3f26218e31e",
  measurementId: "G-KFENXYV1J3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default getFirestore(app);
